// 越南语
module.exports = {
    public: {
        confirm: 'Xác nhận',
        cancel: 'Hủy',
        reset: 'Đặt lại',
        search: 'Tìm kiếm',
        RefreshSucceeded: 'Làm mới thành công',
        noMoreData: 'Không còn dữ liệu',
        pullingText: 'Kéo để làm mới...',
        ReleaseText: 'Thả để làm mới...',
        loadingText: 'Đang tải...',
        noData: 'Không có dữ liệu',
        copyTxt: 'Sao chép',
        copySuccess: 'Sao chép thành công',
        amount: 'Số tiền',
        buy: 'Mua',
        orderNo: 'Số đơn hàng',
        selectLang: 'Chọn ngôn ngữ',
        light: 'Ánh sáng',
        dark: 'Tối',
        All: 'Tất cả',
        DigitalCurrency: 'Tiền điện tử',
        foreignExchange: 'Ngoại hối',
        futures: 'Hợp đồng tương lai',
        stockIndex: 'Chỉ số cổ phiếu',
        stock: 'Cổ phiếu',
        BalanceNot: 'Số dư không đủ',
        optional: 'Tùy chọn',
        market: 'Thị trường',
        USDTcontract: 'Hợp đồng USDT',
        Fiatcurrencycontract: 'Hợp đồng fiat',
        spot: 'Hàng hóa',
        secondContract: 'Hợp đồng giây',
        emptyTxt: 'Không có bản ghi nào',
        down: 'Tải về',
    },
    tabBar: {
        home: 'Trang chủ',
        market: 'Khám phá',
        trade: 'Giao dịch',
        heel: 'Dạy chị',
        asset: 'Tài sản',
        my: 'Của tôi',
    },
    about: {
        title: 'Giới thiệu',
        version: 'Phiên bản',
        about: 'Về chúng tôi',
        ProductIntroduction: 'Giới thiệu sản phẩm',
        Termofservice: 'Điều khoản dịch vụ',
        PrivacyAgreement: 'Thỏa thuận quyền riêng tư',
        Riskstatement: 'Thông báo rủi ro',
        whitePaper: 'Sách trắng',
    },
    asset: {
        Overview: 'Tổng quan',
        contract: 'Hợp đồng',
        wallet: 'Ví',
        Totalassetvaluation: 'Định giá tổng tài sản',
        supportswithdrawal: 'Tất cả tài sản của bạn đều hỗ trợ rút',
        Recharge: 'Nạp tiền',
        Contractaccount: 'Tài khoản hợp đồng',
        Spotaccount: 'Tài khoản hàng hóa',
        Walletaccount: 'Tài khoản ví',
        ValuationContractAssets: 'Định giá tài sản hợp đồng',
        profitloss: 'Lãi lỗ',
        Transfer: 'Chuyển',
        occupy: 'Khóa',
        available: 'Có sẵn',
        Viewallpositions: 'Xem tất cả vị trí',
        Valuationspotassets: 'Định giá tài sản hàng hóa',
        Hidezerobalanceassets: 'Ẩn tài sản có số dư bằng 0',
        balance: 'Số dư',
        ValuationWalletAssets: 'Định giá tài sản ví',
        Withdrawal: 'Rút tiền',
        Walletbalance: 'Số dư ví',
        Cryptocurrencyrecharge: 'Nạp tiền điện tử',
        Fiatcurrencyrecharge: 'Nạp tiền pháp định',
        From: 'Từ',
        To: 'Đến',
        UsdtContractaccount: 'Tài khoản hợp đồng USDT',
        FiatContractaccount: 'Tài khoản hợp đồng tiền pháp định',
        Currency: 'Loại tiền',
        quantity: 'Số lượng',
        availablebalance: 'Số dư có sẵn',
        Insufficientavailablebalance: 'Số dư có sẵn không đủ',
        Transfersuccessful: 'Chuyển thành công',
        flashcash: 'Đổi nhanh',
        flashcashsuccessful: 'Đổi nhanh thành công',
    },
    auth: {
        title: 'Xác minh danh tính',
        gj: 'Quốc tịch',
        tipsgj: 'Chọn quốc tịch',
        userName: 'Họ và tên',
        tips1: 'Nhập họ và tên',
        IDNumber: 'Số chứng minh',
        tips2: 'Nhập số chứng minh',
        base: 'Xác minh cơ bản',
        high: 'Xác minh nâng cao',
        zmz: 'Ảnh mặt trước chứng minh',
        bmz: 'Ảnh mặt sau chứng minh',
        tips3: 'Vui lòng tải lên ảnh mặt trước chứng minh',
        tips4: 'Vui lòng tải lên ảnh mặt sau chứng minh',
        btn: 'Gửi',
        upbtn: 'Thay đổi chứng minh',
        subMsg: 'Gửi thành công, vui lòng đợi phê duyệt',
        upMsg: 'Sau khi thay đổi sẽ được phê duyệt lại, xác nhận thay đổi chứng minh?',
        wait: 'Đang phê duyệt',
        fail: 'Xác minh thất bại',
        success: 'Xác minh thành công',
        cardType: 'Loại chứng minh',
        idCard: 'CMND',
        passport: 'Hộ chiếu',
        driverlicense: 'Giấy phép lái xe',
        AssetCertification: 'Xác minh tài sản',
        AccountType: 'Loại tài khoản',
        holdingamount: 'Số tiền nắm giữ',
        Accountscreenshot: 'Ảnh chụp tài khoản',
        bankaccount: 'Tài khoản ngân hàng',
        IRAaccount: 'Tài khoản IRA',
        stockaccount: 'Tài khoản cổ phiếu',
        other: 'Khác',
        AccountTypetips: 'Vui lòng chọn loại tài khoản',
        Accountscreenshottips: 'Vui lòng tải lên ảnh chụp tài khoản',
    },
    activity: {
        inviteTxt: 'Mỗi lời mời 1 người bạn, bạn sẽ nhận được {amount} USD, hỗ trợ hoa hồng ba cấp tối đa',
        invitebtn: 'Mời và nhận hoa hồng',
        rechargeTxt: 'Khi cấp dưới nạp tiền, bạn sẽ nhận được {amount}% hoa hồng, hỗ trợ hoa hồng ba cấp tối đa',
        rechargebtn: 'Hoa hồng nạp tiền',
        authTxt: 'Xác thực danh tính thành công sẽ nhận ngay {amount} USD',
        authbtn: 'Xác thực danh tính',
        inviteRewardTxt: '<p><strong>Mời bạn bè, dễ dàng nhận 30 USD</strong></p><p><br></p><p>1. Mục tiêu hoạt động</p><p><br></p><p>Đối tượng: Người dùng mới và cũ đều có thể tham gia, khuyến khích người dùng hiện tại chủ động mời bạn bè đăng ký và hoàn thành các thao tác được yêu cầu, nhằm mở rộng lượng người dùng của nền tảng.</p><p>Yêu cầu chính: Thông qua cơ chế giới thiệu, giúp người dùng mới nhanh chóng tham gia và tạo tăng trưởng theo kiểu lan truyền, đồng thời người mời sẽ nhận được phần thưởng thực tế, tăng mức độ gắn bó và trung thành của người dùng.</p><p><br></p><p>2. Thời gian hoạt động</p><p><br></p><p>20/05/2023 – Có hiệu lực dài hạn (sẽ được kiểm tra định kỳ hoặc kết thúc sau khi được thông báo).</p><p><br></p><p>3. Đối tượng tham gia</p><p><br></p><p>Bất kể người dùng nào đã đăng ký nền tảng và hoàn thành xác thực danh tính cơ bản đều có thể trở thành người mời (A).</p><p>Người được mời (B) phải đăng ký mới qua liên kết hoặc mã mời và hoàn tất xác thực danh tính mới được xem là hợp lệ.</p><p><br></p><p>4. Quy định tham gia</p><p><br></p><p>Cách mời:</p><p>Người mời (A) vào “Trang cá nhân” → “Mời bạn bè” → sao chép liên kết/mã mời của riêng mình;</p><p>Chia sẻ cho bạn bè (B) để họ đăng ký qua web hoặc ứng dụng.</p><p><br></p><p>Yêu cầu đối với người được mời:</p><p>Người được mời (B) phải sử dụng liên kết hoặc mã mời do A cung cấp để hoàn tất đăng ký lần đầu;</p><p>Sau khi đăng ký, trong vòng 7 ngày phải hoàn thành xác thực danh tính và đạt mức nạp tối thiểu (ví dụ: nạp lần đầu ≥ 1000 USD hoặc tương đương).</p><p><br></p><p>Phân cấp:</p><p>Chương trình hỗ trợ tối đa 3 cấp thưởng.</p><p>Cấp 1 (trực tiếp): A mời B đăng ký trực tiếp.</p><p>Cấp 2: B mời C, A nhận hoa hồng cấp hai;</p><p>Cấp 3: C mời D, A nhận hoa hồng cấp ba;</p><p>Đến cấp 4 trở đi (D mời E…) sẽ không tính vào thu nhập của A.</p><p><br></p><p>5. Chi tiết phần thưởng</p><p><br></p><p>Phần thưởng cấp 1 (trực tiếp):</p><p>Sau khi B đã nạp và xác thực danh tính, người mời A nhận 30 USD.</p><p><br></p><p>Phần thưởng cấp 2 (gián tiếp):</p><p>Khi B mời C và C thỏa điều kiện tương tự, A nhận 15 USD.</p><p><br></p><p>Phần thưởng cấp 3:</p><p>Khi C mời D và D thỏa điều kiện, A nhận 10 USD.</p><p><br></p><p>Hình thức phát thưởng:</p><p>Hệ thống tự nhận diện quan hệ ba cấp, khi cấp dưới thỏa điều kiện, A sẽ nhận phần thưởng tự động vào tài khoản tài sản trong <strong>48 giờ</strong>.</p><p><br></p><p>6. Ví dụ quy trình</p><p><br></p><p>A đăng nhập GlobalEx → vào “Trang cá nhân” → “Mời bạn bè” → sao chép liên kết/mã mời;</p><p>A gửi cho B;</p><p>B nhấp vào liên kết hoặc nhập mã mời → chuyển tới trang đăng ký → đăng ký email → xác thực danh tính và nạp ≥ 1000 USD;</p><p>Sau khi hoàn tất, B liên hệ hỗ trợ để yêu cầu phần thưởng, hệ thống xét duyệt và chuyển 30 USD cho A trong 48 giờ;</p><p>Nếu B mời C thỏa điều kiện, A tự nhận 15 USD; nếu C mời D thỏa điều kiện, A tự nhận 10 USD.</p><p><br></p><p>7. Kiểm soát rủi ro và lưu ý</p><p><br></p><p>Phòng gian lận:</p><p>Mỗi số điện thoại/email chỉ được mời một lần; cùng IP, chứng minh nhân dân… sẽ bị hệ thống kiểm soát rủi ro;</p><p>Với các tài khoản chất lượng thấp, đăng ký ồ ạt trên cùng thiết bị/mạng, hệ thống sẽ xem xét thủ công và có thể hủy phần thưởng;</p><p><br></p><p>Hình phạt:</p><p>Nếu phát hiện kẻ gian mời người nhận nhằm mục đích lạm dụng, rút tiền bất hợp pháp, nền tảng có quyền hủy thưởng và đóng băng tài khoản.</p><p><br></p>',
        rechargeRewardTxt: '<p><strong>Hoa hồng từ nạp cấp dưới, lợi nhuận ngay lập tức</strong></p><p><br></p><p><strong>1. Mục tiêu hoạt động</strong></p><p><br></p><p>Đối tượng: Người mời cấp 1 (A) đã xác thực danh tính và đã mời ít nhất một cấp dưới (B, C, D); khi họ nạp trên nền tảng, A sẽ nhận tỷ lệ hoa hồng do nền tảng quy định để phát triển chuỗi lan tỏa và thúc đẩy hoạt động người dùng.</p><p><br></p><p>Yêu cầu chính: Thông qua cơ chế “hoa hồng từ nạp”, liên kết hành vi nạp của người dùng mới với quyền lợi của người mời, tạo vòng lặp “mời – nạp – nhận hoa hồng – mời tiếp”, nhằm thúc đẩy giữ chân vốn và tăng hoạt động nền tảng.</p><p><br></p><p><strong>2. Thời gian hoạt động</strong></p><p><br></p><p>Hoạt động liên tục từ 20/05/2023; tỷ lệ hoa hồng hoặc thời gian kết thúc sẽ được điều chỉnh và thông báo trước.</p><p><br></p><p><strong>3. Đối tượng tham gia</strong></p><p><br></p><p>Người mời A: phải xác thực danh tính và đã mời ít nhất một B hoàn tất xác thực.</p><p><br></p><p>Cấp dưới B, C, D: là người được A hoặc cấp dưới A mời; khi họ nạp, A sẽ nhận hoa hồng.</p><p><br></p><p><strong>4. Quy định tham gia</strong></p><p><br></p><p><strong>Phân cấp:</strong></p><p>Cấp 1 (B trực tiếp): B nạp ≥ 1000 USD và A nhận hoa hồng 1%;</p><p>Cấp 2 (C): C nạp ≥ 1000 USD và A nhận hoa hồng 0,5%;</p><p>Cấp 3 (D): D nạp ≥ 1000 USD và A nhận hoa hồng 0,3%;</p><p>Chỉ áp dụng đến cấp 3.</p><p><br></p><p><strong>Kênh & mức tối thiểu:</strong></p><p>Áp dụng mọi kênh nạp (fiat hoặc mã hóa), nhưng mỗi lần nạp phải ≥ 1000 USD để được tính thưởng;</p><p><br></p><p><strong>Tỷ lệ hoa hồng:</strong></p><p>Cấp 1: 1,0% (ví dụ: B nạp 1000 USD → A nhận 10 USD);</p><p><br></p><p>Cấp 2: 0,5% (C nạp 1000 USD → A nhận 5 USD);</p><p><br></p><p>Cấp 3: 0,3% (D nạp 1000 USD → A nhận 3 USD);</p><p><br></p><p><strong>Phát hoa hồng:</strong></p><p>Nền tảng sẽ phát trong vòng 24 giờ sau khi nạp được ghi nhận vào tài khoản;</p><p>Người dùng có thể kiểm tra nguồn và thời gian hoa hồng tại “Ví của tôi” → “Chi tiết hoa hồng”.</p><p><br></p><p>5. Ví dụ quy trình:</p><p><br></p><p>A đăng nhập APP → “Trang cá nhân” → “Mời bạn bè” → sao chép liên kết/mã;</p><p>A gửi cho B;</p><p>B đăng ký → xác thực → nạp ≥ 1000 USD;</p><p>Sau khi vào tài khoản, hệ thống tự động tính: tổng nạp × 1% = hoa hồng cho A; trong vòng 24 giờ tiền chuyển;</p><p>B sau khi xác thực có thể mời C; nếu C nạp,:</p><p>B nhận C nạp × 1%;</p><p>A nhận C nạp × 0,5%;</p><p><br></p><p>C mời D; nếu D nạp,:</p><p>C nhận D nạp × 1%;</p><p>B nhận D nạp × 0,5%;</p><p>A nhận D nạp × 0,3%;</p><p><br></p><p><strong>6. Kiểm soát rủi ro & lưu ý</strong></p><p><br></p><p><strong>Phòng thao túng:</strong></p><p>Cùng một người không được giao dịch vòng; nền tảng theo dõi các giao dịch nhỏ lặp lại hoặc nạp‑rút lớn trong thời gian ngắn để kiểm tra, khi cần sẽ hủy thưởng;</p><p>Nếu phát hiện xâm lợi từ rút nhanh hoặc hoạt động tần suất cao, hệ thống có thể hủy thưởng;</p><p><br></p><p><strong>Tuân thủ pháp lý:</strong></p><p>Nếu phát hiện nguy cơ rửa tiền hoặc rút tiền bất hợp pháp, nền tảng có quyền đóng băng hoa hồng và báo cáo cơ quan chức năng.</p><p><br></p>',
        authRewardTxt: '<p><strong>Xác thực danh tính, nhận ngay 50 USD</strong></p><p><br></p><p>1. Mục tiêu hoạt động</p><p><br></p><p>Đối tượng: Người dùng mới và cũ (chưa xác thực) đều có thể tham gia; nhằm thu hút người dùng hoàn tất xác thực và giữ chân họ, đồng thời khuyến khích những người do dự trong quá trình xác thực.</p><p>Mục tiêu chính: Thông qua phần thưởng tiền mặt, trực tiếp khuyến khích người dùng hoàn tất xác thực danh tính, nâng cao chất lượng kiểm soát rủi ro và tỷ lệ KYC, đảm bảo nền tảng vận hành hợp pháp.</p><p><br></p><p>2. Thời gian hoạt động</p><p><br></p><p>20/05/2023 – Có hiệu lực dài hạn</p><p><br></p><p>3. Đối tượng tham gia</p><p><br></p><p>Người dùng mới: lần đầu đăng ký trên GlobalEx và hoàn tất xác thực trong thời gian khuyến mãi;</p><p>Người dùng cũ: đã đăng ký trước nhưng chưa xác thực, hoàn tất trong thời gian chương trình để nhận thưởng;</p><p><br></p><p>4. Quy định xác thực</p><p><br></p><p>Yêu cầu:</p><p>Tải lên ảnh giấy tờ rõ ràng (chứng minh nhân dân/hộ chiếu/ GPLX) hai mặt và ảnh bán thân cầm giấy tờ;</p><p>Yêu cầu nhận diện khuôn mặt với ánh sáng đầy đủ, không che mặt, đáp ứng kiểm tra liveness;</p><p>Sau khi gửi, thời gian xét duyệt thường hoàn tất trong 24 giờ;</p><p><br></p><p>Phần thưởng:</p><p>Mỗi người dùng hoàn tất xác thực trong thời gian chương trình (mới hoặc cũ) sẽ nhận 50 USD;</p><p><br></p><p>Phát thưởng:</p><p>Hệ thống chuyển 50 USD vào tài khoản hợp đồng fiat trong vòng 24 giờ sau khi xác thực; sau khi hoàn thành 10 giao dịch bình thường, có thể rút tiền;</p><p><br></p><p>Nếu hồ sơ không đầy đủ hoặc bị từ chối, cần bổ sung và xác thực lại để nhận thưởng;</p><p><br></p><p>5. Ví dụ quy trình:</p><p><br></p><p>Người dùng đăng nhập APP → “Xác thực danh tính” → bắt đầu quá trình;</p><p>Tải lên ảnh CMND/hộ chiếu/GPLX hai mặt;</p><p>Hệ thống tự so khớp; nếu không qua, cần chụp lại theo yêu cầu;</p><p>Sau khi duyệt, hệ thống sẽ nhận dạng và chuyển 50 USD vào tài khoản hợp đồng fiat trong 24 giờ;</p><p><br></p><p>6. Kiểm soát rủi ro & lưu ý:</p><p><br></p><p><strong>Phòng gian lận:</strong></p><p>Mỗi giấy tờ chỉ được nhận một lần; cùng IP/thiet bị đăng ký nhiều giấy tờ, hệ thống sẽ kiểm soát hoặc từ chối;</p><p>Nếu phát hiện làm giả giấy tờ hoặc chỉnh sửa ảnh, sẽ bị từ chối và đóng băng tài khoản;</p><p><br></p><p><strong>Bảo vệ dữ liệu:</strong></p><p>Nền tảng cam kết tài liệu và dữ liệu hình ảnh chỉ dùng cho KYC và rủi ro, không tiết lộ khi chưa được phép;</p><p>Sau khi xác thực, ảnh và video sẽ được mã hóa và lưu trữ theo quy định pháp luật;</p><p><br></p><p>&nbsp;</p>',
    },
    bill: {
        title: 'Chi tiết tài chính',
        audit: 'Chờ phê duyệt',
        success: 'Thành công',
        refuse: 'Từ chối',
        recharge: 'Nạp tiền',
        recharge_currency: 'Nạp tiền điện tử',
        recharge_legal: 'Nạp tiền pháp định',
        withdrawal: 'Rút tiền',
        withdrawal_currency: 'Rút tiền điện tử',
        cancel_withdrawal_currency: 'Hủy rút tiền',
        withdrawal_legal: 'Rút tiền pháp định',
        cancel_withdrawal_legal: 'Hủy rút tiền pháp định',
        transfer: 'Chuyển',
        usdt_contract_wallet: 'Hợp đồng USDT -> Ví',
        legal_contract_wallet: 'Hợp đồng pháp định -> Ví',
        coin_currency_wallet: 'Hàng hóa -> Ví',
        wallet_usdt_contract: 'Ví -> Hợp đồng USDT',
        wallet_legal_contract: 'Ví -> Hợp đồng pháp định',
        wallet_coin_currency: 'Ví -> Hàng hóa',
        finance_wallet: 'Dạy chị -> Ví',
        wallet_finance: 'Ví -> Dạy chị',
        usdt_contract_currency: 'Hợp đồng USDT -> Giao ngay',
        finance_currency: 'Tài chính -> Giao ngay',
        currency_usdt_contract: 'Giao ngay -> Hợp đồng USDT',
        currency_finance: 'Giao ngay -> Tài chính',
        legal_contract_currency: 'Hợp đồng tiền pháp định -> Giao ngay',
        currency_legal_contract: 'Giao ngay -> Hợp đồng tiền pháp định',
        recharge_reward: 'Hoa hồng nạp tiền từ cấp dưới',
        auth_reward: 'Thưởng xác thực danh tính',
        flashcash: 'Đổi nhanh',
        trade: 'Giao dịch',
        create_order: 'Tạo đơn hàng',
        settlement_order: 'Thanh toán đơn hàng',
        cancel_order: 'Hủy đơn hàng',
        finance_return: 'Hoàn vốn tài chính',
        finance_income: 'Lợi nhuận tài chính',
        other: 'Khác',
        commission_transfer: 'Chuyển hoa hồng',
        platform_gift: 'Quà tặng từ nền tảng',
        system_regulation: 'Thay đổi số dư',
        freeze_thaw: 'Đóng băng rã đông',
        c2c_create_order: 'C2C Tạo đơn hàng',
        c2c_cancel_order: 'C2C Hủy đơn hàng',
        Currency: 'Loại tiền',
        type: 'Loại',
        SelectCurrency: 'Chọn loại tiền',
        SelectType: 'Chọn loại',
        SelectDate: 'Chọn ngày',
        to: 'Đến',
        Contractfunds: 'Quỹ hợp đồng',
        Spotfunds: 'Quỹ hàng hóa',
        Walletfunds: 'Quỹ ví',
        RechargeRecord: 'Lịch sử nạp',
        WithdrawalRecord: 'Lịch sử rút',
        virtualcoin: 'Tiền ảo',
        Legaltender: 'Tiền pháp định',
    },
    c2c: {
        limit: 'Hạn mức',
        available: 'Có sẵn',
        price: 'Đơn giá',
        needpay: 'Bạn cần thanh toán',
        willreceive: 'Bạn sẽ nhận được',
        Insufficientlimit: 'Hạn mức không đủ',
        Exceedinglimit: 'Vượt quá hạn mức',
        Exceedingavailable: 'Vượt quá số dư khả dụng',
        balance: 'Số dư',
        InsufficientBalance: 'Số dư không đủ',
        OrderHistory: 'Lịch sử đơn hàng',
        quantity: 'Số lượng',
        amountmoney: 'Số tiền',
        OrderNo: 'Mã đơn hàng',
        inprogress: 'Đang tiến hành',
        Completed: 'Đã hoàn thành',
        Cancelled: 'Đã hủy',
        all: 'Tất cả',
        chat: 'Trò chuyện',
        picture: '[Hình ảnh]',
        Read: 'Đã đọc',
        Unread: 'Chưa đọc',
        inputTips: 'Nhập tin nhắn của bạn tại đây',
        send: 'Gửi',
    },
    common: {
        title: 'Tất cả chức năng',
        Depositcoins: 'Nạp tiền',
        Rechargefiatcurrency: 'Nạp tiền fiat',
        Withdraw: 'Rút tiền',
        documentation: 'Dạy chị',
        Activecenter: 'Hoạt động',
        Invitationforrebate: 'Mời bạn bè nhận hoa hồng',
        Detailsoffunds: 'Chi tiết tài chính',
        Positiondetails: 'Chi tiết vị trí',
        Notice: 'Thông tin',
        Aboutus: 'Về chúng tôi',
        helpcenter: 'Trung tâm hỗ trợ',
        customer: 'Hỗ trợ khách hàng',
        Cryptocurrencywithdrawal: 'Rút tiền điện tử',
        Fiatmoneywithdrawal: 'Rút tiền pháp định',
    },
    forgotPass: {
        title: 'Đặt lại mật khẩu',
        btn: 'Xác nhận',
        Password: 'Mật khẩu mới',
        placeholder: 'Nhập mật khẩu mới',
        success: 'Cài đặt thành công',
    },
    finance: {
        financeAssetAmount: 'Giá trị tài sản tài chính',
        financeAccount: 'Tài khoản tài chính',
        financefund: 'Quỹ tài chính',
        financeProduct: 'Sản phẩm tài chính',
        Applynow: 'Đăng ký ngay',
        term: 'Kỳ hạn',
        investment: 'Số tiền đầu tư',
        Mininvestment: 'Số tiền đầu tư tối thiểu',
        Maxinvestment: 'Số tiền đầu tư tối đa',
        buyNum: 'Số lần mua',
        Myincome: 'Thu nhập của tôi',
        Dailyearnings: 'Thu nhập hàng ngày',
        yieldmaturity: 'Lợi nhuận khi đáo hạn',
        timeaxis: 'Trục thời gian',
        Subscriptiondate: 'Ngày đăng ký',
        valuedate: 'Ngày bắt đầu tính lãi',
        duedate: 'Ngày đáo hạn',
        Receiptdate: 'Ngày nhận tiền',
        day: 'Ngày',
        financeOrderList: 'Lịch sử tài chính',
        interestrate: 'Lãi suất',
        Revenueamount: 'Số tiền thu nhập',
        Settlementamount: 'Số tiền thanh toán',
        regularly: 'Định kỳ',
        eecurrent: 'Không kỳ hạn',
        redemption: 'Rút vốn',
        redemptionTips: 'Xác nhận rút sản phẩm tài chính này',
        loan: 'Khoản vay',
        LoanRange: 'Khoảng vay',
        LoanAmount: 'Số tiền vay',
        loanTerm: 'Thời hạn vay',
        Dailyinterestrate: 'Lãi suất hàng ngày',
        Totalinterest: 'Tổng lãi',
        Repaymentmethod: 'Phương thức trả nợ',
        Repaymentofmaturity: 'Trả cả gốc và lãi một lần khi đến hạn',
        Estimatedreturn: 'Số tiền ước tính phải trả',
        Ihavereadandagree: 'Tôi đã đọc và đồng ý',
        LoanAgreement: 'Thỏa thuận vay',
        Immediatelymoney: 'Vay ngay',
        Minimumloanamount: 'Số tiền vay tối thiểu',
        Maximumloanamount: 'Số tiền vay tối đa',
        Applicationsuccessfulreview: 'Đăng ký thành công, chờ xét duyệt từ hệ thống',
        Loanrecords: 'Lịch sử vay',
        Pendingreview: 'Đang chờ xét duyệt',
        issued: 'Đã giải ngân',
        Repaid: 'Đã trả',
        Rejected: 'Bị từ chối',
        LoanDate: 'Ngày vay',
        AmountDue: 'Số tiền phải trả',
        repayment: 'Trả nợ',
        homeAddress: 'Địa chỉ nhà chi tiết',
        homeAddressTips: 'Vui lòng nhập địa chỉ nhà chi tiết',
        emergencyContact: 'Người liên hệ khẩn cấp',
        emergencyContactTips: 'Vui lòng nhập người liên hệ khẩn cấp',
        emergencyPhone: 'Số điện thoại người liên hệ khẩn cấp',
        emergencyPhoneTips: 'Vui lòng nhập số điện thoại người liên hệ khẩn cấp',
        emergencyEmail: 'Email người liên hệ khẩn cấp',
        emergencyEmailTips: 'Vui lòng nhập email người liên hệ khẩn cấp',
        isHouse: 'Bạn có sở hữu bất động sản của riêng mình không',
        houseImg: 'Nếu có bất động sản, vui lòng cung cấp ảnh chứng minh quyền sở hữu',
        certImg: 'Mặt trước giấy tờ (CMND/Hộ chiếu/Bằng lái xe)',
        certImgTips: 'Vui lòng tải lên mặt trước giấy tờ (CMND/Hộ chiếu/Bằng lái xe)',
        certBackImg: 'Mặt sau giấy tờ (CMND/Hộ chiếu/Bằng lái xe)',
        certBackImgTips: 'Vui lòng tải lên mặt sau giấy tờ (CMND/Hộ chiếu/Bằng lái xe)',
        trustImg: 'Ảnh chụp màn hình điểm tín dụng',
        trustImgTips: 'Vui lòng tải lên ảnh chụp màn hình điểm tín dụng',
        yesTxt: 'Có',
        noTxt: 'Không',
        EstimatedReturn: 'Lợi nhuận dự kiến',
        seeDetail: 'Xem chi tiết',
        orderDetails: 'Chi tiết đơn hàng',
        simFinanceTips: 'Vui lòng chuyển sang tài khoản thực để sử dụng chức năng tài chính',
    },
    heel: {
        tips: 'Mời bạn đón chờ~',
    },
    home: {
        optional: 'Tùy chọn',
        HotList: 'Danh sách nóng',
        more: 'Xem thêm',
        Welcomeback: 'Chào mừng trở lại',
        loginBtn: 'Đăng nhập',
        CompleteAuth: 'Hoàn tất xác minh danh tính để mở khóa đầy đủ dịch vụ',
        authBtn: 'Xác minh ngay',
        toptit1: 'Giao dịch mọi lúc, mọi nơi',
        toptit2: 'Đầu tư chỉ với một chạm, dễ dàng sinh lời!',
    },
    login: {
        title: 'Đăng nhập',
        Account: 'Tài khoản',
        Password: 'Mật khẩu',
        btn: 'Đăng nhập',
        placeholder: 'Nhập số điện thoại',
        placeholder1: 'Nhập mật khẩu',
        ForgotPassword: 'Quên mật khẩu',
        noAccount: 'Chưa có tài khoản?',
        Registration: 'Đăng ký',
        server: 'Liên hệ hỗ trợ',
        success: 'Đăng nhập thành công',
        checkedAgree: 'Vui lòng đồng ý thỏa thuận quyền riêng tư trước',
        rememberpassword: 'Nhớ mật khẩu',
        agreewith: 'Đồng ý',
        PrivacyAgreement: 'Thỏa thuận quyền riêng tư',
    },
    market: {
        product: 'Sản phẩm',
        Latestprice: 'Giá mới nhất',
        volume: 'Khối lượng giao dịch',
        ChangeRatio: 'Tỷ lệ thay đổi',
        Addoptional: 'Thêm vào danh sách tự chọn',
        optional: 'Tự chọn',
        market: 'Thị trường',
        Editselfselection: 'Chỉnh sửa tự chọn',
        operate: 'Thao tác',
        SelectAll: 'Chọn tất cả',
        delete: 'Xóa',
        time: 'Thời gian',
    },
    position: {
        title: 'Chi tiết vị trí',
        totalassets: 'Tổng tài sản',
        profitloss: 'Lãi lỗ',
        Holdingassets: 'Tài sản đang giữ',
        margin: 'Tiền ký quỹ',
        orderAmount: 'Số tiền đơn hàng',
        availableassets: 'Tài sản có sẵn',
        product: 'Sản phẩm',
        direction: 'Hướng',
        Entrustedprice: 'Giá ủy thác',
        Entrustednum: 'Số lượng ủy thác',
        Currentprice: 'Giá hiện tại',
        Stoplossprice: 'Giá dừng lỗ',
        stopSurplusPrice: 'Giá chốt lời',
        Leverageratio: 'Tỷ lệ đòn bẩy',
        Entrustedtime: 'Thời gian ủy thác',
        orderno: 'Mã đơn hàng',
        marketvalue: 'Giá trị thị trường',
        SettlementPrice: 'Giá thanh toán',
        Settlementtime: 'Thời gian thanh toán',
        Settakeprofitloss: 'Đặt chốt lời dừng lỗ',
        closeposition: 'Đóng vị trí',
        Position: 'Vị trí hiện tại',
        commission: 'Lệnh lịch sử',
        Settlement: 'Giao dịch lịch sử',
        Settingsuccessful: 'Cài đặt thành công',
        Confirmclosingorder: 'Xác nhận đóng lệnh',
        Closingsuccessfully: 'Đóng lệnh thành công',
        cancelorder: 'Xác nhận hủy lệnh',
        Cancelsuccessfully: 'Hủy thành công',
        status: 'Trạng thái',
        changeRate: 'Phí',
    },
    property: {
        title: 'Chi tiết tài sản',
        totalassets: 'Tổng tài sản',
        profitloss: 'Lãi lỗ',
        Holdingassets: 'Tài sản đang giữ',
        margin: 'Tiền ký quỹ',
        availableassets: 'Tài sản có sẵn',
        investmentportfolio: 'Danh mục đầu tư',
        Recentincomesituation: 'Tình hình thu nhập gần đây',
        Seemore: 'Xem thêm',
        IncomeDetails: 'Chi tiết thu nhập',
    },
    recharge: {
        mixAmount: 'Số tiền nạp tối thiểu',
        subMsg: 'Gửi thành công, vui lòng chờ duyệt',
        amountMsg: 'Nhập số tiền',
        VoucherMsg: 'Vui lòng tải lên biên lai thanh toán',
        Depositcoins: 'Nạp coin',
        Rechargecurrency: 'Loại tiền nạp',
        RechargecurrencyTips: 'Số lượng nạp trên 200USDT, thanh toán nhanh',
        Depositaddress: 'Địa chỉ nạp coin',
        Rechargetoaccount: 'Nạp vào tài khoản',
        Walletaccount: 'Tài khoản ví',
        Rechargequantity: 'Số lượng nạp',
        Paymentvoucher: 'Biên lai thanh toán',
        Youneedtorecharge: 'Bạn cần nạp',
        Rechargenow: 'Nạp ngay',
        Rechargefiatcurrency: 'Nạp tiền pháp định',
        Topupfiatcurrency: 'Nạp tiền pháp định',
        paymentcurrency: 'Loại tiền thanh toán',
        paymentcurrencyTips: 'Số tiền nạp trên 200USD, thanh toán nhanh',
        Fiatcontractaccount: 'Tài khoản hợp đồng tiền pháp định',
        Rechargeamount: 'Số tiền nạp',
        Youwillget: 'Bạn sẽ nhận được',
        network: 'Mạng',
        notsupportedAddress: 'Địa chỉ không được hỗ trợ',
        selectaccount: 'Vui lòng chọn tài khoản',
    },
    register: {
        title: 'Đăng ký',
        send: 'Gửi mã xác minh',
        Resend: 'Gửi lại',
        sendSuccess: 'Gửi thành công',
        PhoneNumber: 'Số điện thoại',
        Mailbox: 'Email',
        Captcha: 'Mã xác minh',
        Password: 'Mật khẩu',
        ConfirmPassword: 'Xác nhận mật khẩu',
        PromoteCode: 'Mã khuyến mãi',
        OrgCode: 'Mã tổ chức',
        btn: 'Đăng ký',
        placeholder0: 'Nhập số điện thoại',
        placeholder1: 'Nhập mật khẩu',
        placeholder2: 'Nhập mật khẩu xác nhận',
        placeholder3: 'Nhập mã ID người giới thiệu',
        placeholder4: 'Nhập mã xác minh',
        placeholder5: 'Nhập email',
        emaiError: 'Định dạng email không hợp lệ',
        success: 'Đăng ký thành công',
        message: 'Mật khẩu ít nhất 6 ký tự',
        message1: 'Mật khẩu xác nhận ít nhất 6 ký tự',
        message2: 'Mật khẩu không khớp',
        searchCountryMsg: 'Nhập quốc gia, mã vùng để tìm kiếm',
        haveAccount: 'Đã có tài khoản?',
        goLogin: 'Đăng nhập',
        titleTips: 'Bắt đầu từ đăng ký!',
        Invitationcode: 'Mã mời',
        Iagreewith: 'Tạo tài khoản tức là tôi đồng ý với',
        and: 'và',
    },
    safe: {
        SecuritySettings: 'Cài đặt bảo mật',
        Accountsecurity: 'Bảo mật tài khoản',
        phone: 'Điện thoại',
        Notyetbound: 'Chưa liên kết',
        mailbox: 'Email',
        Loginpassword: 'Mật khẩu đăng nhập',
        Fundcode: 'Mã quỹ',
        Settings: 'Cài đặt',
        Withdrawaladdressmanagement: 'Quản lý địa chỉ rút tiền',
        Addwithdrawaladdress: 'Thêm địa chỉ rút tiền',
        Withdrawalcurrency: 'Tiền rút',
        Withdrawaladdress: 'Địa chỉ rút tiền',
        WithdrawaladdressTips: 'Nhập địa chỉ rút tiền',
        WithdrawaladdressError: 'Vui lòng nhập địa chỉ rút tiền hợp lệ',
        remark: 'Ghi chú',
        confirm: 'Xác nhận',
        Addedsuccessfully: 'Thêm thành công',
        Pleaseselectcurrency: 'Vui lòng chọn loại tiền',
        Bindmailbox: 'Liên kết email',
        Bindmobilephone: 'Liên kết số điện thoại',
        ChangeLoginPassword: 'Thay đổi mật khẩu đăng nhập',
        Setfundpassword: 'Cài đặt mật khẩu quỹ',
        BindmailboxTips: 'Vui lòng liên kết email trước, liên kết ngay?',
        Addnewaddress: 'Thêm địa chỉ mới',
        Confirmdeleteaddress: 'Xác nhận xóa địa chỉ rút tiền',
    },
    share: {
        title: 'Chia sẻ kiếm tiền',
        commission: 'Hoa hồng',
        Commissionrecord: 'Lịch sử hoa hồng',
        Commissiontransferout: 'Chuyển hoa hồng ra ngoài',
        Transferoutrecord: 'Lịch sử chuyển ra ngoài',
        Invitefriends: 'Mời bạn bè',
        Invitationrecord: 'Lịch sử mời',
        Commissioncommission: 'Chia hoa hồng',
        ReferralCode: 'Mã giới thiệu',
        Firstlevelmembers: 'Cấp 1 thành viên',
        Secondlevelmembers: 'Cấp 2 thành viên',
        Thirdlevelmembers: 'Cấp 3 thành viên',
        Transferbalance: 'Chuyển vào số dư',
        Confirmtransferout: 'Xác nhận chuyển ra ngoài',
        Transfersuccessful: 'Chuyển ra ngoài thành công',
        amount: 'Số tiền chuyển ra',
        Transferfiaaccount: 'Chuyển đến tài khoản hợp đồng',
    },
    trade: {
        high: 'Giá cao nhất 24h',
        low: 'Giá thấp nhất 24h',
        vol: 'Khối lượng giao dịch 24h',
        buy: 'Mua',
        sell: 'Bán',
        buyBtn: 'Mua vào',
        sellBtn: 'Bán ra',
        Present: 'Lệnh thị trường',
        Limit: 'Lệnh giới hạn',
        limitMsg: 'Giá',
        markPriceMsg: 'Theo giá tối ưu hiện tại',
        num: 'Số lượng',
        zyzsSet: 'Cài đặt chốt lời cắt lỗ',
        zyPrice: 'Chốt lời',
        zsPrice: 'Cắt lỗ',
        smallMin: 'M',
        hour: 'H',
        dayMin: 'D',
        Position: 'Vị thế',
        Viewalltransactions: 'Xem tất cả giao dịch',
        product: 'Sản phẩm',
        direction: 'Hướng',
        Entrustedprice: 'Giá ủy thác',
        Entrustednum: 'Số lượng ủy thác',
        Latestprice: 'Giá mới nhất',
        volume: 'Khối lượng giao dịch',
        ChangeRatio: 'Tỷ lệ thay đổi',
        buyBtnConfirm: 'Xác nhận mua vào',
        sellBtnConfirm: 'Xác nhận bán ra',
        totalAmount: 'Số tiền',
        Margin: 'Ký quỹ',
        balance: 'Số dư khả dụng',
        buyLimtMsg: 'Mua dài chỉ nhập giá thấp hơn giá thị trường',
        sellLimtMsg: 'Mua ngắn chỉ nhập giá cao hơn giá thị trường',
        putNummsg: 'Vui lòng nhập số lượng',
        putLimitPriceMsg: 'Vui lòng nhập giá giới hạn',
        pleaseAuth: 'Vui lòng xác thực danh tính',
        orderSuccess: 'Giao dịch thành công',
        Fullwarehouse: 'Toàn bộ kho',
        corkado: 'Có thể mua dài',
        Kato: 'Mua dài',
        openable: 'Có thể bán ngắn',
        Openempty: 'Bán ngắn',
        purchasable: 'Có thể mua',
        vendibility: 'Có thể bán',
        Orderconfirmation: 'Xác nhận đặt lệnh',
        Averageopeningprice: 'Giá mở trung bình',
        Marketprice: 'Giá thị trường',
        Openingquantity: 'Số lượng mở',
        Stoplossprice: 'Giá cắt lỗ',
        stopSurplusPrice: 'Giá chốt lời',
        Averageprice: 'Giá trung bình',
        buyLimtMsg2: 'Mua vào chỉ nhập giá thấp hơn giá thị trường',
        sellLimtMsg2: 'Bán ra chỉ nhập giá cao hơn giá thị trường',
        authTips: 'Vui lòng xác thực danh tính, đi đến xác thực',
        profundity: 'Độ sâu',
        deal: 'Giao dịch',
        contract: 'Hợp đồng',
        TradeNow: 'Giao dịch ngay',
        CloseTime: 'Thành phố Hugh',
        buyUp: 'Mua tăng',
        buyDown: 'Mua giảm',
        selectSeconds: 'Chọn thời gian đáo hạn',
        buyNums: 'Số lượng mua',
        minbuyNums: 'Mua tối thiểu',
        incomeRates: 'Tỷ suất lợi nhuận',
        buySuccessTips: 'Mua thành công',
        secondNums: 'Giây',
        simulatedTrading: 'Giao dịch mô phỏng',
    },
    upPassword: {
        title: 'Đổi mật khẩu',
        oldPassword: 'Mật khẩu cũ',
        oldPasswordMsg: 'Vui lòng nhập mật khẩu cũ',
        newPassword: 'Mật khẩu mới',
        newPasswordMsg: 'Vui lòng nhập mật khẩu mới',
        twoPassword: 'Xác nhận mật khẩu',
        twoPasswordMsg: 'Vui lòng nhập lại mật khẩu',
        twoinputMsg: 'Mật khẩu nhập lại không khớp',
        passwordTypeMsg: 'Mật khẩu yêu cầu 6 chữ số',
        submsg: 'Thay đổi thành công',
        btn: 'Xác nhận thay đổi',
    },
    user: {
        Avatarchange: 'Thay đổi ảnh đại diện',
        Replacesuccessfully: 'Thay đổi thành công',
        authenticated: 'Đã xác thực',
        Notcertifiedyet: 'Chưa xác thực',
        Invitefriends: 'Mời bạn bè',
        Activecenter: 'Trung tâm hoạt động',
        Identityauthentication: 'Xác thực danh tính',
        Completedverification: 'Đã hoàn tất xác thực',
        Tobeverified: 'Đang chờ xác thực',
        SecuritySettings: 'Cài đặt bảo mật',
        Lang: 'Chọn ngôn ngữ',
        changeTheme: 'Chuyển đổi giao diện',
        helpcenter: 'Trung tâm trợ giúp',
        Aboutus: 'Về chúng tôi',
        out: 'Đăng xuất',
        outmsg: 'Xác nhận đăng xuất',
        trustscore: 'Điểm tín nhiệm',
    },
    welcome: {
        title1: 'Thanh khoản thị trường hàng đầu',
        tips1: '99% đơn hàng thực hiện ở mức giá cao nhất',
        title2: '12 năm uy tín',
        tips2: 'Giao dịch tiền điện tử mọi lúc, mọi nơi trên nền tảng đáng tin cậy',
        title3: 'Lợi ích đặc biệt cho VIP',
        tips3: 'Trở thành VIP để nhận giảm phí giao dịch, đổi tiền, rút tiền',
        title4: '100,000 USDT giao dịch mô phỏng',
        tips4: 'Thực hành giao dịch không rủi ro',
        bnt1: 'Đăng ký nhận ngay 10 USDT',
        bnt2: 'Đăng nhập',
    },
    with: {
        Withdrawcurrency: 'Rút tiền',
        currencyofwithdrawal: 'Loại tiền rút',
        Withdrawaladdress: 'Địa chỉ rút tiền',
        Addwithdrawaladdress: 'Thêm địa chỉ rút tiền',
        Withdrawalquantity: 'Số lượng rút',
        availablebalance: 'Số dư khả dụng',
        WithdrawaladdressTips: 'Chưa cài đặt địa chỉ rút, đi đến cài đặt?',
        selectWithdrawaladdress: 'Chọn địa chỉ rút tiền',
        Insufficientavailablebalance: 'Số dư không đủ',
        Withdrawingfiatcurrency: 'Rút tiền pháp định',
        Withdrawaloffiatcurrency: 'Rút tiền pháp định',
        Currentbalance: 'Số dư hiện tại',
        Currencyreceived: 'Loại tiền nhận được',
        WithdrawingfiatcurrencyTips: 'Số tiền rút trên 200 USD, nhận tiền nhanh',
        Withdrawalaccount: 'Tài khoản rút tiền',
        Fiatcontractaccount: 'Tài khoản hợp đồng pháp định',
        Withdrawalamount: 'Số tiền rút',
        Youneedwithdrawmoney: 'Bạn cần rút',
        Youwillget: 'Bạn sẽ nhận được',
        Withdrawimmediately: 'Rút ngay',
        mixAmount: 'Số tiền rút tối thiểu ',
        subMsg: 'Đã gửi thành công, vui lòng chờ phê duyệt',
    },
}